export default __webpack_public_path__ + "static/media/summer.4271beac.gif";